
export const SocialProfile = ({ inputs }) => (
  <div className="social-profile">
    <p className="social-profile__title">I vostri profili social</p>
    <p className="social-profile__subtitle">Qui puoi inserire i link ai tuoi profili social.</p>
    {inputs}
  </div>
)